import { useAppContext } from '@contexts/AppContext';

const TARGET_APP_VERSION = 3;

export default function useNativeAppVersionCheck() {
  const { isNativeApp, nativeAppVersion } = useAppContext();

  const nativeMajorVersion = nativeAppVersion ? parseInt(nativeAppVersion.split('.')[0], 10) : 0;

  return {
    isApp3_0OrGreater: nativeMajorVersion >= TARGET_APP_VERSION,
    isNativeApp: !!isNativeApp,
  };
}
